import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    fetchPuttPerformanceChart,
 } from 'Actions';

class StrokesChart extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
    };

    
    constructor(props) {
      
        super(props);
        
        this.state = {  
            
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            loader:false,
            contact:'',
            shotstring:'',
            showModal:false,
            distance:'',
            putttype:'',
        };
    }

    handleChange(e, val){

        if(val==1){
            var distance=e.target.value;
            var putttype=this.state.putttype;
            this.setState({ distance:distance });
        }
        
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        this.props.fetchPuttPerformanceChart(student, stdate, eddate, distance, putttype).then((data) => {   
                        
           

        }); 
    }
    


render() {

    const { puttperformancechart,  loading} = this.props; 
    const datacount=puttperformancechart.length;
    const linedata = puttperformancechart.strokeline; 
    
    return(
        <div>   
            <RctCollapsibleCard>
                <div className="row">
                    
                    <div className="col-sm-12 col-lg-5">
                        <h2>STROKES GAINED CHART FOR ALL SESSIONS</h2>                         
                    </div>
                    <div className="col-sm-12 col-lg-7">
                        <div className="row">
                        <div className="col-sm-12 col-lg-1">
                             <h5 style={{marginTop:"10px"}}>Distance</h5>
                        </div>    
                        <div className="col-sm-12 col-lg-4">                        
                        <select  name="distance" id="distance" className="form-control form-control-alternative" onChange={e => this.handleChange(e, 1)} required>
                            <option value="">All</option>
                            <option value="1">0-3</option>
                            <option value="2">4-6</option>
                            <option value="3">7-10</option>
                            <option value="4">11-15</option>
                            <option value="5">16-20</option>
                            <option value="6">21-25</option>
                            <option value="7">26-30</option>
                            <option value="8">31-35</option>                                            
                            <option value="9">36-40</option>
                            <option value="10">41-50</option>
                            <option value="11">51-100</option>
                        </select>
                        </div>
                        
                        </div>
                    </div>
                    <div className="col-sm-12 col-lg-12" style={{marginBottom:"20px"}}></div>
                    {datacount==0?
                     <div className="col-sm-12 col-lg-12">
                      <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                     </div> 
                    :    
                    <>
                    <div className="col-sm-12 col-lg-12">
                            
                    <ResponsiveContainer width={800} height={300} style={{margin:"1px"}}> 
                        <LineChart data={linedata}>
                            <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                            <YAxis stroke={ChartConfig.axesColor} domain={['dataMin -1', 'dataMax +1']}/>
                            <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                            <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />                                                            
                            <Line type="bumpX" dataKey="y" stroke={ChartConfig.color.info} label={{ fill: '#757474', fontSize: 15, position:'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                        </LineChart>
                    </ResponsiveContainer>
                            
                    </div>
                    
                    
                    </>
                    }          
                </div>

                </RctCollapsibleCard>
                
                
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ puttperformance}) => {
    const { puttperformancechart, loading } = puttperformance;
    return { puttperformancechart, loading };
   
}


export default connect(mapStateToProps, {
    fetchPuttPerformanceChart, 
})(StrokesChart);
